module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter has-text-left"
  }, [_c('b-field', {
    class: {
      'is-danger': _vm.errors.has('partner-title')
    },
    attrs: {
      "label": "Заголовок"
    }
  }, [_c('b-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "partner-title"
    },
    model: {
      value: (_vm.computedPartner.title),
      callback: function($$v) {
        _vm.$set(_vm.computedPartner, "title", $$v)
      },
      expression: "computedPartner.title"
    }
  })], 1), _vm._v(" "), _c('b-checkbox', {
    staticClass: "mt-10",
    model: {
      value: (_vm.computedPartner.showTitle),
      callback: function($$v) {
        _vm.$set(_vm.computedPartner, "showTitle", $$v)
      },
      expression: "computedPartner.showTitle"
    }
  }, [_vm._v("\n      Показывать заголовок\n    ")]), _vm._v(" "), _c('b-field', {
    staticClass: "mt-10",
    attrs: {
      "label": "Ссылка"
    }
  }, [_c('b-input', {
    model: {
      value: (_vm.computedPartner.url),
      callback: function($$v) {
        _vm.$set(_vm.computedPartner, "url", $$v)
      },
      expression: "computedPartner.url"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    staticClass: "logo-wrapper",
    attrs: {
      "label": "Логотип"
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.imageUrl) ? _c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": function($event) {
        return _vm.$refs.loadLogoInput.click()
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить\n      ")]) : _c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.removeImage
    }
  }, [_c('a', {
    staticClass: "button is-danger"
  }, [_vm._v("-")]), _vm._v("Удалить\n      ")]), _vm._v(" "), _c('input', {
    ref: "loadLogoInput",
    attrs: {
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.loadLogo
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-fullwidth",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("СОХРАНИТЬ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-fullwidth",
    attrs: {
      "to": {
        name: 'Partners'
      }
    }
  }, [_vm._v("ОТМЕНИТЬ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f38689f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Partners/Editor.vue
// module id = 934
// module chunks = 0